<template>
  <div class="notice-popup">
    <div class="popup-header">
      <div class="header-content">
        <i class="fa fa-cogs text-primary"></i>
        <h2 class="title">CAMDS系统更新通知</h2>
        <span class="version">版本 12.1</span>
      </div>
      <button class="close-btn">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <!-- 弹窗内容 -->
    <div class="popup-body">
      <div class="update-date">
        <i class="fa fa-calendar-o"></i>
        <span>更新日期：2025年8月27日</span>
      </div>

      <div class="update-content">
        <h3 class="content-title">本次更新内容如下：</h3>

        <ul class="update-list">
          <li class="update-item">
            <span class="item-number">1.</span>
            <span>辅助校验工具对于自建的表单也可以进行自定义规则校验。</span>
          </li>
          <li class="update-item">
            <span class="item-number">2.</span>
            <span>BOM上传功能（高级上传工具）界面增加了“编辑”按钮，上传后的数据可以直接进入编辑页面。</span>
          </li>
          <li class="update-item important">
            <span class="item-number">3.</span>
            <span>被标记为保密的物质，如被列入GADSL清单，系统将会自动公布该物质。</span>
            <span class="important-tag">重要</span>
          </li>
          <li class="update-item">
            <span class="item-number">4.</span>
            <span>优化IC转换工具大表单上传速度的问题。</span>
          </li>
          <li class="update-item">
            <span class="item-number">5.</span>
            <span>SCIP通报义务分析功能进一步完善，起动分析后可以后台运行，且可以显示当前进度。</span>
          </li>
          <li class="update-item">
            <span class="item-number">6.</span>
            <span>已接收列表查看时，可以自定义显示列或隐藏列。</span>
          </li>
          <li class="update-item">
            <span class="item-number">7.</span>
            <span>C2C工具导出数据表中的件号由零部件号改为供货编号。</span>
          </li>
          <li class="update-item">
            <span class="item-number">8.</span>
            <span>修复当前已发现Bug。</span>
            <ul class="bug-list">
              <li><span class="bug-number">1)</span> C2C转换工具在线上传失败的问题。</li>
              <li><span class="bug-number">2)</span> 辅助校验工具清单上传报错的问题。</li>
              <li><span class="bug-number">3)</span> 添加本企业联系人时卡住的问题。</li>
              <li><span class="bug-number">4)</span> 承诺书中节点顺序与树结构中节点顺序不一致的问题</li>
              <li><span class="bug-number">5)</span> 特殊字符过滤的部分问题。</li>
            </ul>
          </li>
        </ul>

        <div class="additional-info">
          <p>详细信息请参考最新版使用手册。如您有更多问题，请与CAMDS管理中心联系。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.update-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.update-popup {
  width: 100%;
  max-width: 800px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.popup-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-content .fa-cogs {
  color: #165DFF;
  font-size: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #1D2129;
  margin: 0;
}

.version {
  font-size: 14px;
  color: #86909C;
  background-color: #F2F3F5;
  padding: 2px 8px;
  border-radius: 4px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 18px;
  color: #86909C;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #F2F3F5;
  color: #1D2129;
}

.popup-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.update-date {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #4E5969;
  margin-bottom: 20px;
  font-size: 14px;
}

.content-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #1D2129;
}

.update-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.update-item {
  margin-bottom: 12px;
  padding-left: 24px;
  position: relative;
  line-height: 1.5;
}

.item-number {
  position: absolute;
  left: 0;
  font-weight: 600;
  color: #165DFF;
}

.important {
  padding-right: 60px;
}

.important-tag {
  position: absolute;
  right: 0;
  background-color: #F53F3F;
  color: white;
  font-size: 12px;
  padding: 1px 6px;
  border-radius: 3px;
  font-weight: 500;
}

.bug-list {
  list-style: none;
  padding: 8px 0 0 24px;
  margin: 0;
}

.bug-list li {
  margin-bottom: 6px;
  position: relative;
  padding-left: 20px;
}

.bug-number {
  position: absolute;
  left: 0;
  color: #86909C;
}

.additional-info {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px dashed #E5E6EB;
  color: #4E5969;
  font-size: 14px;
}

.popup-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.manual-btn, .contact-btn, .confirm-btn {
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.manual-btn {
  color: #165DFF;
  background-color: #E8F3FF;
  border-color: #D1E9FF;
}

.manual-btn:hover {
  background-color: #D1E9FF;
}

.contact-btn {
  color: #00B42A;
  background-color: #E6FFED;
  border-color: #B7EB8F;
}

.contact-btn:hover {
  background-color: #B7EB8F;
}

.confirm-btn {
  color: white;
  background-color: #165DFF;
}

.confirm-btn:hover {
  background-color: #0E42D2;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .popup-footer {
    flex-direction: column;
  }

  .manual-btn, .contact-btn, .confirm-btn {
    width: 100%;
  }

  .important {
    padding-right: 0;
  }

  .important-tag {
    position: static;
    margin-left: 8px;
  }
}
</style>
